// Shared styles + tiny icon components used by the extracted map-surface
// components. Kept together so several sibling files can pull from one
// spot without a circular import via GuestMapSurface.js.

import React from 'react';
import { MessageCircleMore, Globe2 } from 'lucide-react';

export const actionButtonSurface = {
  background: 'var(--surface)',
  border: '1px solid var(--card-border)',
  boxShadow: 'var(--premium-shadow-nested)',
};

export const MessageBubbleSvg = ({ size = 20 }) => (
  <MessageCircleMore size={size} color="var(--text-2)" strokeWidth={1.9} />
);

export const SocialMediaSvg = ({ size = 20 }) => (
  <Globe2 size={size} color="var(--text-2)" strokeWidth={2} />
);
